import {createSelector} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {initialLocation} from './constants'
import {RootState} from './interface'
import {getLocationState} from './utils'

export const routerSelector = (state: RootState) => state.router

export const locationSelector = createSelector(routerSelector, (router) => {
    const location = router.location ?? initialLocation
    const {pathname, search} = location

    return {
        key: location.key,
        location,
        pathname,
        search,
        /** 타입 가드된 location.state */
        state: getLocationState(location),
        query: qs.parse(search),
    }
})

/** Query 에서 Application 이 공통으로 이해할수 있는 값 전달 */
export const pageQueryInfoSelector = createSelector(locationSelector, ({query}) => {
    return {
        query,
        page: query.page,
        category: query.category,
        search: query.search,
        keyword: query.keyword,
    }
})
